import { trackAddToList } from "@DSG/Common/DSGTracking";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getWishList, GetWishListApiParameter } from "@insite/client-framework/Services/WishListService";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
addToChainAfter(chain, ExecuteOnSuccessCallback, addAddToListTracking);

// get the type of props using this
type TrackingParameters = Parameters<typeof ExecuteOnSuccessCallback>[0];

async function addAddToListTracking(props: TrackingParameters) {
    const state = props.getState();

    const result = props.result.wishList;
    const updatedWishList = await getWishList({
        wishListId: result?.id,
        expand: ["getAllLines"],
    } as GetWishListApiParameter);
    const lines = props.parameter.productInfos.map(productInfo => ({
        productId: productInfo.productId,
        qtyOrdered: productInfo.qtyOrdered,
        unitOfMeasure: productInfo.unitOfMeasure,
    })) as ProductInfo[];

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: props.parameter.productInfos.map(productInfo => ({
                productId: productInfo.productId,
                qtyOrdered: productInfo.qtyOrdered,
                unitOfMeasure: productInfo.unitOfMeasure,
            })),
            onComplete: realTimePricingProps => {
                if (realTimePricingProps?.apiResult) {
                    realTimePricingProps.apiResult.realTimePricingResults?.forEach(pricing => {
                        updatedWishList?.wishListLineCollection?.forEach(line => {
                            if (line.productId === pricing.productId && line.unitOfMeasure === pricing.unitOfMeasure) {
                                line.pricing = pricing;
                            }
                        });
                    });
                }
            },
        }),
    );
    trackAddToList(updatedWishList, lines, state);
}
